window.$ = window.jQuery = require('jquery')

// Dropdown, Popover, and Tooltip depend on Popper
// require('@popperjs/core');

// Bootstrap
// import {Collapse} from 'bootstrap';
// import {Popover} from 'bootstrap';
// import {Toast} from 'bootstrap';
// import {Tooltip} from 'bootstrap';
// import {Alert} from 'bootstrap';
// import {Modal} from 'bootstrap';
// import {Dropdown} from 'bootstrap';
import {Carousel} from 'bootstrap'

// Plugins
require('jquery-validation')
require('jquery-validation/dist/additional-methods')

import form from './form'

form()

$(document).ready(function() {
    if ($('.carousel').length) {
        // $('.carousel').carousel({
        //     interval: 6000
        // })
        const carousel = new Carousel($('.carousel'), {
            interval: 6000
        })
    }

    $('.dropdown .dropdown').each(() => {
        const $self = $(this)
        const handle = $self.children('[data-toggle="dropdown"]')
        $(handle).click(() => {
            const submenu = $self.children('.dropdown-menu')
            $(submenu).toggle()
            return false
        })
    })

    // $('button[name=sendmail]').click(function(e) {
    //     e.preventDefault()
    //     let valid = true
    //     if (!$('textarea[name=message]').val()) {
    //         $('#block-answer').html('<div class="alert alert-danger">message is required.</div>').fadeIn()
    //         valid = false
    //     }
    //     if (!$('input[name=phone]').val()) {
    //         $('#block-answer').html('<div class="alert alert-danger">phone is required.</div>').fadeIn()
    //         valid = false
    //     }
    //     if (!$('input[name=email]').val()) {
    //         $('#block-answer').html('<div class="alert alert-danger">email is required.</div>').fadeIn()
    //         valid = false
    //     }
    //     if (!$('input[name=name]').val()) {
    //         $('#block-answer').html('<div class="alert alert-danger">name is required.</div>').fadeIn()
    //         valid = false
    //     }
    //     if (grecaptcha.getResponse() == '') {
    //         $('#block-answer').html('<div class="alert alert-danger">solve the captcha.</div>').fadeIn()
    //         valid = false
    //     }
    //     let msg = 'name: ' + $('input[name=name]').val() +
    //         '<br/>email: ' + $('input[name=email]').val() +
    //         '<br/>phone: ' + $('input[name=phone]').val() +
    //         '<br/><br/>message: ' + $('textarea[name=message]').val()
    //     let data = {
    //         'to': 'taijimike@hotmail.com',
    //         //"to": "leonardo@gaunte.com",
    //         'subj': 'FullCircle Form',
    //         'msg': msg
    //     }
    //     if (valid) {
    //         $.ajax({
    //             type: 'POST',
    //             //url: 'https://gaunte.com/php/sendmail/',
    //             url: 'https://api.gaunte.com/sendmail/',
    //             dataType: 'json',
    //             contentType: 'application/json',
    //             data: JSON.stringify(data),
    //             success: function(r) {
    //                 if (r.type == 'success') {
    //                     $('form[name=contactform] input, form[name=contactform] textarea').delay(6000).val('')
    //                     $('#block-answer').html('<div class="alert alert-success"><p>message sent!</p></div>').fadeIn().delay(6000).fadeOut()
    //                     console.log(r)
    //                 } else {
    //                     $('#block-answer').html('<div class="alert alert-danger"><p>' + r.message + '</p></div>').fadeIn()
    //                     console.log(r)
    //                 }
    //             },
    //             error: function(r) {
    //                 $('#block-answer').html('<div class="alert alert-danger"><p>' + r.message + '</p></div>').fadeIn()
    //                 console.log(r)
    //             }
    //         })
    //     }
    // })

    // $('form[name=contactform] input, form[name=contactform] textarea').keyup(function() {
    //     $('#block-answer').fadeOut()
    // })
})
